

app.controller('solCtrl', function ($rootScope, $scope, services, $location, ngTableParams, $filter, FileUploader, fctService, ServiceQcm, toastr) {// $sce = pour ng-bind-html

    var _DEBUG = 0;
    $scope.url_ = $rootScope.url_;

    $scope.chargementEnCours = 1;  // au debut, pas de pb avec watch...
    $scope.choixPAGE = 3; // on affiche la solution
    $scope.afficheFichier = 0;
    $scope.listeSolution = [];

    if (typeof ($rootScope.qcmSelectionne) == "undefined") { $scope.data = []; }
    else $scope.listeSolution = fctService.tableauSolution($rootScope.qcmSelectionne);

    /******************************************************************************************************/

    $scope.init = function () {

        if (typeof ($rootScope.qcmSelectionne.id) == "undefined") {
            //$scope.choixQCM = -1;
            //$rootScope.menuSelectionne = 1;
            //document.location.href = "/#/1qcm"
            $location.path('/0lst');//document.location.href
        } else {

            //$scope.choixQCM = $rootScope.qcmSelectionne.id;
            $scope.chargementEnCours = 0;
            //$scope.nbEtudiant = $rootScope.qcmSelectionne.nbEtudiant;
            $rootScope.menuSelectionne = 2;
            $scope.qcmSelectionne = $rootScope.qcmSelectionne;
            $scope.counter = 0;
            //new ServiceQcm.tableauSolution($rootScope.qcmSelectionne, tab).then(function(data){
            ////$scope.data = fctService.tableauSolution($rootScope.qcmSelectionne)
            //$scope.data =  $scope.listeSolution;
            if ($rootScope.qcmSelectionne.qcmSolution[0] == "(") {
                $scope.afficheFichier = 1;
                toastr.info('___Vous devez indiquer les réponses et le barême___');
            }
            services.solution($rootScope.qcmSelectionne.id).then(function (data) {

                $rootScope.qcmSelectionne.qcmSolution = data.data[0].qcmSolution;
                $scope.qcmSelectionne.qcmSolution = $rootScope.qcmSelectionne.qcmSolution;

                $scope.listeSolution = fctService.tableauSolution($rootScope.qcmSelectionne);
                /******************************************************************************************************/
                var nb_max = Math.max($scope.listeSolution.length, 100);

                /******* tableau ***/
                $scope.tableParams = new ngTableParams({
                    page: 1,            // show first page
                    count: 10           // count per page
                }, {
                    total: $scope.listeSolution.length, // length of data
                    counts: [10, 25, nb_max],
                    getData: function ($defer, params) {
                        $scope.data = params.filter() ? $filter('filter')($scope.listeSolution, params.filter()) : $scope.listeSolution;
                        $scope.data = params.sorting() ? $filter('orderBy')($scope.data, params.orderBy()) : $scope.listeSolution;
                        $scope.data = $scope.data.slice((params.page() - 1) * params.count(), params.page() * params.count());

                        $defer.resolve($scope.data);
                    }
                });
                /******************************************************************************************************/
            });


        };
    }
    /******************************************************************************************************/
    // FONCTION QUAND ON CLIQUE !!!

    $scope.$watch('listeSolution', function (newValue, oldValue) {
        if (typeof (newValue) == "undefined") { return; }
        if (typeof (oldValue) == "undefined") { return; }

        if ($scope.chargementEnCours == 1) {
            $scope.chargementEnCours = 0;
            //alert("exit1")
            return;
        }

        $scope.counter = $scope.counter + 1;
        if ($scope.counter == 1) return;
        //    alert("newValue[i].j = "+newValue[0].j);

        var trouve = false, i = 0, nbQ = $rootScope.qcmSelectionne.nbQuestion, lettre = 0;

        //trouver si on à changer la valeur des points (j-f-v) ?
        for (i = 0; (i < nbQ) && !trouve; i++) {
            //JUSTE
            if (!(newValue[i].j == oldValue[i].j)) {//alert('A'+(i+1));
                lettre = 'j'; trouve = true; oldV = oldValue[i].j; newV = newValue[i].j;
                $scope.listeSolution[i].j = newV;
                if (isNaN(newV)) {// si la valeur n'est pas un nombre, on ne fait rien... on attend que ce soit un nombre
                    $scope.listeSolution[i].j = oldV;
                    return;
                } else if (newV == null) {
                    $scope.listeSolution[i].j = 0;
                    return;
                }
            }
            //FAUX
            if (!(newValue[i].f == oldValue[i].f)) {//alert('B'+(i+1));
                lettre = 'f'; trouve = true; oldV = oldValue[i].f; newV = newValue[i].f;
                $scope.listeSolution[i].f = newV;
                if (isNaN(newV)) {// si la valeur n'est pas un nombre, on ne fait rien... on attend que ce soit un nombre
                    $scope.listeSolution[i].f = oldV;
                    return;
                } else if (newV == null) {
                    $scope.listeSolution[i].f = 0;
                    return;
                }

            }
            //VIDE
            if (!(newValue[i].v == oldValue[i].v)) {//alert('C'+(i+1));
                lettre = 'v'; trouve = true; oldV = oldValue[i].v; newV = newValue[i].v;
                $scope.listeSolution[i].v = newV;
                if (isNaN(newV)) {// si la valeur n'est pas un nombre, on ne fait rien... on attend que ce soit un nombre
                    $scope.listeSolution[i].v = oldV;
                    return;
                } else if (newV == null) {
                    $scope.listeSolution[i].v = 0;
                    return;
                }
            }
            //BONUS
            if (!(newValue[i].b == oldValue[i].b)) {//alert('C'+(i+1));
                lettre = 'b'; trouve = true; oldV = oldValue[i].b; newV = newValue[i].b;
                $scope.listeSolution[i].b = newV;
                if (isNaN(newV)) {// si la valeur n'est pas un nombre, on ne fait rien... on attend que ce soit un nombre
                    $scope.listeSolution[i].b = oldV;
                    return;
                } else if (newV == null) {
                    $scope.listeSolution[i].b = 0;
                    return;
                }
            }
        }

        //alert("sortie3="+trouve+", i="+i+", j="+j)
        if (trouve) {    // ICI : on a changé la valeur de juste/faux/vide d'une question

            indice = i - 1
            // éviter de repasser
            // Maintenant : BDD
            // 1.on remplit la table "bareme"... (js : en arrière plan, non ploquant !)
            if (lettre == 'j') {
                $rootScope.qcmSelectionne.ptSiJuste[indice] = newV;
                $rootScope.qcmSelectionne.justeTotal = $rootScope.qcmSelectionne.justeTotal + newV - oldV;
                services.modifBareme($rootScope.qcmSelectionne.id, indice, newV, $rootScope.qcmSelectionne.ptSiFaux[indice], $rootScope.qcmSelectionne.ptSiVide[indice], 0).then(function (data) {
                });
            }
            if (lettre == 'f') {
                $rootScope.qcmSelectionne.ptSiFaux[indice] = newV;
                services.modifBareme($rootScope.qcmSelectionne.id, indice, $rootScope.qcmSelectionne.ptSiJuste[indice], newV, $rootScope.qcmSelectionne.ptSiVide[indice], 0).then(function (data) {
                });
            }
            if (lettre == 'v') {
                $rootScope.qcmSelectionne.ptSiVide[indice] = newV;
                services.modifBareme($rootScope.qcmSelectionne.id, indice, $rootScope.qcmSelectionne.ptSiJuste[indice], $rootScope.qcmSelectionne.ptSiFaux[indice], newV, 0).then(function (data) {
                });
            }
            if (lettre == 'b') {
                $rootScope.qcmSelectionne.ptSiBonus[indice] = newV
                if (newV) { res = 1; $scope.qcmSelectionne.nbBonus++; }
                else { res = 0; $scope.qcmSelectionne.nbBonus--; }
                services.modifBareme($rootScope.qcmSelectionne.id, indice, $rootScope.qcmSelectionne.ptSiJuste[indice], $rootScope.qcmSelectionne.ptSiFaux[indice], $rootScope.qcmSelectionne.ptSiVide[indice], res).then(function (data) {
                });
            }

            // INSERT INTO BDD : table bareme !!!
            //requete ="INSERT INTO `bareme`(`idqcm`,`question` ,`juste` ,`faux` , `vide`) VALUES ("+1282+","+1+","+1+","+-.1+","+0)

            // refaire le calcul des moyennes (en changeant la question)
            new ServiceQcm.calculNotes($rootScope.qcmSelectionne);
            return;// c'était un point du bareme... pas une solution !
        }

        trouve = false;
        i = 0;
        lettre = 0;
        var decoche = false;

        // on cherche la croix cochée... la différence !
        for (i = 0; (i < nbQ) && !trouve; i++) {
            if (!(newValue[i].A == oldValue[i].A)) {//alert('A'+(i+1));
                lettre = 1; trouve = true; if (newValue[i].A == false) decoche = true;
            }
            if (!(newValue[i].B == oldValue[i].B)) {//alert('B'+(i+1));
                lettre = 2; trouve = true; if (newValue[i].B == false) decoche = true;
            }
            if (!(newValue[i].C == oldValue[i].C)) {//alert('C'+(i+1));
                lettre = 3; trouve = true; if (newValue[i].C == false) decoche = true;
            }
            if (!(newValue[i].D == oldValue[i].D)) {//alert('D'+(i+1));
                lettre = 4; trouve = true; if (newValue[i].D == false) decoche = true;
            }
            if (!(newValue[i].E == oldValue[i].E)) {//alert('E'+(i+1));
                lettre = 5; trouve = true; if (newValue[i].E == false) decoche = true;
            }
        }

        if (trouve) {
            var cAvant = $rootScope.qcmSelectionne.qcmSolution[i - 1]
            if (!decoche) {
                // cas n°1 : une seule réponse par question
                // on décoche les autres croix
                if ($rootScope.qcmSelectionne.UneSeuleReponse % 2 == 1) {
                    if (lettre != 1) newValue[i - 1].A = false;
                    if (lettre != 2) newValue[i - 1].B = false;
                    if (lettre != 3) newValue[i - 1].C = false;
                    if (lettre != 4) newValue[i - 1].D = false;
                    if (lettre != 5) newValue[i - 1].E = false;
                }
                //return;
            }

            // calcule du caractère qui a été modifié (dans la solution)
            var v = 0, rep = "";
            if (newValue[i - 1].A) { v += 1; rep = "A"; } else { rep = "_"; }
            if (newValue[i - 1].B) { v += 2; rep += "B"; } else { rep += "_"; }
            if (newValue[i - 1].C) { v += 4; rep += "C"; } else { rep += "_"; }
            if (newValue[i - 1].D) { v += 8; rep += "D"; } else { rep += "_"; }
            if (newValue[i - 1].E) { v += 16; rep += "E"; } else { rep += "_"; }
            var c = String.fromCharCode(40 + v);
            var caseM = i - 1;

            var chaine = $rootScope.qcmSelectionne.qcmSolution;
            var lg = $rootScope.qcmSelectionne.qcmSolution.length;
            var nbQ = $rootScope.qcmSelectionne.qcmSolution.length;

            if (caseM == 0)
                $rootScope.qcmSelectionne.qcmSolution = c + chaine.substring(1, lg);
            else if (caseM == nbQ - 1)
                $rootScope.qcmSelectionne.qcmSolution = chaine.substring(0, lg - 1) + c;
            else if (caseM > 0)
                $rootScope.qcmSelectionne.qcmSolution = chaine.substring(0, caseM) + c + chaine.substring(caseM + 1, lg);

            if ($rootScope.qcmSelectionne.modeCalcul == 1) { // 0 ou 1 ou 10
                //reponse=$rootScope.qcmSelectionne.qcmSolution[caseM];
                if (c == '(' || c == ')' || c == '*' || c == ',' || c == '0' || c == '8') $rootScope.qcmSelectionne.QuneSeuleReponse[caseM] = 1;
                else $rootScope.qcmSelectionne.QuneSeuleReponse[caseM] = 0;
            }

            $scope.qcmSelectionne = $rootScope.qcmSelectionne;
            newValue[i - 1].reponse = rep;

            // Maintenant : BDD
            services.updateSol($rootScope.qcmSelectionne.id, $rootScope.qcmSelectionne.qcmSolution).then(function (data) {
                //la BDD est mise à jour (reponse)
                // maintenant, il faut mettre les notes à jour...
            });

            // refaire le calcul des moyennes (en changeant la question)**************************************
            new ServiceQcm.calculNotes($rootScope.qcmSelectionne);
            $scope.tableParams.reload();


        }

    }, true);
    /******************************************************************************************************/

    var uploader = $scope.uploader = new FileUploader({
        url: '/envoiSolution/',
        formData: [{ 'token': $rootScope.user.token, 'id': $rootScope.qcmSelectionne.id, 'nbQuestion': $rootScope.qcmSelectionne.nbQuestion, 'nbR': $rootScope.qcmSelectionne.nbReponse, 'nbReponse': $rootScope.qcmSelectionne.nbReponse, 'UneSeuleReponse': $rootScope.qcmSelectionne.UneSeuleReponse % 2, 'nbNumero': 0, 'multi_nbpage': $rootScope.qcmSelectionne.multi_nbpage, 'typeCoin': $rootScope.qcmSelectionne.typeCoin, 'remord': $rootScope.qcmSelectionne.remord }]


        //formData:[{'id':$rootScope.qcmSelectionne.id, 'nbQuestion':$rootScope.qcmSelectionne.nbQuestion, 'UneSeuleReponse':$rootScope.qcmSelectionne.UneSeuleReponse%2, 'nbReponse':$rootScope.qcmSelectionne.nbReponse, 'multi_nbpage':$rootScope.qcmSelectionne.multi_nbpage, 'nbNumero':$rootScope.qcmSelectionne.nbNumero, 'typeCoin':$rootScope.qcmSelectionne.typeCoin  }]
    });

    // FILTERS

    uploader.filters.push({
        name: 'customFilter',
        fn: function (item /*{File|FileLikeObject}*/, options) {
            return this.queue.length < 10;
        }
    });

    // CALLBACKS

    uploader.onWhenAddingFileFailed = function (item /*{File|FileLikeObject}*/, filter, options) {
        if (_DEBUG) console.info('onWhenAddingFileFailed', item, filter, options);
    };
    uploader.onAfterAddingFile = function (fileItem) {
        if (_DEBUG) console.info('onAfterAddingFile', fileItem);
    };
    uploader.onAfterAddingAll = function (addedFileItems) {
        if (_DEBUG) console.info('onAfterAddingAll', addedFileItems);
    };
    uploader.onBeforeUploadItem = function (item) {
        if (_DEBUG) console.info('onBeforeUploadItem', item);

        // le nom 'token' est celui définit dans le programme 'satellizer.js' dans node_modules
        item.headers = {
            'Authorization': 'Bearer ' + localStorage.getItem('token')
        };
        $scope.chargementEnCours = 1
    };
    uploader.onProgressItem = function (fileItem, progress) {
        if (_DEBUG) console.info('onProgressItem', fileItem, progress);
    };
    uploader.onProgressAll = function (progress) {
        if (_DEBUG) console.info('onProgressAll', progress);
    };
    uploader.onSuccessItem = function (fileItem, response, status, headers) {
        if (_DEBUG) console.info('onSuccessItem', fileItem, response, status, headers);
    };
    uploader.onErrorItem = function (fileItem, response, status, headers) {
        if (_DEBUG) console.info('onErrorItem', fileItem, response, status, headers);
    };
    uploader.onCancelItem = function (fileItem, response, status, headers) {
        if (_DEBUG) console.info('onCancelItem', fileItem, response, status, headers);
    };
    uploader.onCompleteItem = function (fileItem, response, status, headers) {
        //alert("response="+response)
        //alert("status="+status)
        if (response == -1000) {
            toastr.error("___Ce n'est pas un fichier des solutions ?___");
        } else if (response == -200) {
            toastr.error("___Attention : trop de lignes ?___");
        } else if (response == -300) {
            toastr.error("___Attention : pas assez de ligne ?___");
        } else if (response < 0) {
            toastr.error("___Attention : vérifier les solutions du fichier___");
        } else {
            toastr.success('___Importation des solutions réussie.___');
        }
    };
    uploader.onComplete = function (response, status, headers) {
    };
    uploader.onCompleteAll = function () {
        if (_DEBUG) console.info('onCompleteAll');
        $scope.chargementEnCours = 1;

        // récupérer la solution (voir qcm.js)
        services.solution($rootScope.qcmSelectionne.id).then(function (data) {

            $rootScope.qcmSelectionne.qcmSolution = data.data[0].qcmSolution;
            $scope.qcmSelectionne.qcmSolution = $rootScope.qcmSelectionne.qcmSolution;

            $scope.listeSolution = fctService.tableauSolution($rootScope.qcmSelectionne);

            $scope.chargementEnCours = 1;

            if ($rootScope.qcmSelectionne.nbEtudiant > 0) {

                new ServiceQcm.calculNotes($rootScope.qcmSelectionne).then(function (data) {
                    $scope.qcmSelectionne = data;
                    $rootScope.qcmSelectionne = data;
                    //$scope.choixQCM = qcm.id
                    //alert("fini")
                })

            }
            $scope.chargementEnCours = 0;

        })
            .catch(function (response) {
                toastr.error("___session expirée___");
                $scope.loader = 0;
                $location.path('/QCMscanner');
            })
            .finally(function (data) {
                document.getElementById("myModal").click();
                $scope.tableParams.reload();
            });

        $scope.afficheFichier = 0;
    };

    /******************************************************************************************************/

    $scope.envoyerFichier = function () {
        if ($scope.afficheFichier == 0)
            $scope.afficheFichier = 1;
        else
            $scope.afficheFichier = 0;
    }

    /******************************************************************************************************/
    $scope.cancel = function () { //revenir à la liste des qcm
        //$rootScope.afficheListeQcm=1;
        $location.path('/0lst');
    }
    /******************************************************************************************************/

    /******************************************************************************************************/


});


